import { FC } from "react";
import {
  View,
  TouchableOpacity,
  Text,
  ImageSourcePropType,
  StyleSheet,
  TextStyle,
} from "react-native";

import { Image } from "react-native";

import { theme } from "../../theme/theme";

import { labelText, messages } from "../../resources/strings";
import { getBranPaymentIcon } from "../../resources/ImageHelper";

const PaymentOption: FC<{
  icon: ImageSourcePropType;
  title: string;
  desc: string;
  isSeperator: boolean;
}> = ({ icon, title, desc, isSeperator }) => (
  <View style={[styles.optionRow, { borderBottomWidth: isSeperator ? 1 : 0 }]}>
    <View style={styles.iconWrap}>
      <Image
        resizeMode="contain"
        source={icon}
        style={{ width: theme.spacing.xlg, height: theme.spacing.xlg }}
      />
    </View>

    <View style={styles.textWrap}>
      <Text style={styles.optionTitle}>{title}</Text>
      <Text style={styles.optionDesc}>{desc}</Text>
    </View>
  </View>
);

const PaymentConfirmationModal: FC<{
  onClose: () => void;
  onContinue: () => void;
}> = ({ onClose, onContinue }) => (
  <View style={styles.overlay}>
    <View style={styles.modalContainer}>
      <View style={styles.headerRow}>
        <Text style={styles.title}>{messages.payments.payOnline}</Text>
        <TouchableOpacity onPress={onClose}>
          <Text style={styles.closeIcon}>✕</Text>
        </TouchableOpacity>
      </View>

      <View style={styles.innerPanel}>
        {messages.payments.paymentOptions.map((item, index) => (
          <PaymentOption
            icon={getBranPaymentIcon(item.type)}
            title={item.title}
            desc={item.desc}
            isSeperator={index !== messages.payments.paymentOptions.length - 1}
          />
        ))}
      </View>

      {/* <Text style={styles.footerText}>{messages.payments.confirmation}</Text> */}

      <TouchableOpacity style={styles.continueBtn} onPress={onContinue}>
        <Text style={styles.continueText}>{labelText.button.continue}</Text>
      </TouchableOpacity>
    </View>
  </View>
);

export default PaymentConfirmationModal;

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    position: "absolute",
    height: "100%",
    width: "100%",
    backgroundColor: theme.colors.loaderBg,
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    backgroundColor: "white",
    borderRadius: theme.radius.ssm,
    padding: theme.spacing.lg,
    maxWidth: 500,
    elevation: 5,
    shadowColor: theme.colors.black,
    shadowOpacity: 0.2,
    shadowRadius: theme.radius.sm,
    shadowOffset: { width: 0, height: 3 },
  },
  innerPanel: {
    // backgroundColor: theme.colors.paymentPannelColor,
    borderRadius: theme.radius.sm,
    paddingVertical: theme.spacing.reg,
    // paddingHorizontal: theme.spacing.reg,
    marginBottom: theme.margin.md,
  },
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.margin.md,
  },
  title: {
    fontSize: theme.fontsize.lg,
    fontWeight: theme.fontweight.semiBold as TextStyle["fontWeight"],
  },
  closeIcon: {
    fontSize: theme.fontsize.lg,
    color: theme.colors.text.secondary,
    padding: theme.spacing.xxs,
  },

  optionCard: {
    backgroundColor: theme.colors.paymentPannelColor,
    padding: theme.spacing.md,
    borderRadius: theme.radius.xs,
    marginBottom: theme.margin.reg,
  },

  optionRow: {
    flexDirection: "row",
    alignItems: "flex-start",

    borderColor: theme.colors.seperator,
    paddingVertical: theme.spacing.reg,
  },
  iconWrap: {
    width: theme.spacing.xxl4,
    height: theme.spacing.xxl4,
    borderRadius: theme.radius.xs,
    backgroundColor: theme.colors.primaryLighter,
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.margin.reg,
  },

  textWrap: {
    flex: 1,
  },
  optionTitle: {
    fontSize: theme.fontsize.cs,
    fontWeight: theme.fontweight.medium as TextStyle["fontWeight"],
    marginBottom: theme.margin.xxs,
  },

  optionDesc: {
    fontSize: theme.fontsize.reg,
    color: theme.colors.text.secondary,
    lineHeight: theme.spacing.lg,
  },

  footerText: {
    fontSize: theme.fontsize.ssm,
    color: theme.colors.text.secondary,
    marginTop: theme.margin.xxs,
    marginBottom: theme.margin.lg,
  },

  continueBtn: {
    backgroundColor: theme.colors.button.paymentContinue,
    shadowColor: theme.colors.button.paymentContinue,
    paddingVertical: theme.spacing.reg,
    paddingHorizontal: theme.spacing.xl,
    maxWidth: "40%",
    alignSelf: "center",
    borderRadius: theme.radius.xxs,
    alignItems: "center",
  },

  continueText: {
    color: theme.colors.white,
    fontWeight: theme.fontweight.medium as TextStyle["fontWeight"],
    fontSize: theme.fontsize.cs,
  },
});
